<!-- =========================================================================================
	File Name: ECommerceCheckout.vue
	Description: eCommerce Checkout page
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view">

      <div class="vx-row" v-if="basket.totalQuantity > 0">

          <!-- LEFT COL -->
          <div class="vx-col lg:w-2/3 w-full relative">
              <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="basket.products" style="margin-top: -1.3rem;">
                  <template slot-scope="{data}">
                      <tbody ref="table_modal">
                          <tr v-for="(item,index) in basket.products" :data="item" :key="item.id">
                              <vs-td class="list-view-item mb-base overflow-hidden" style="padding: 0;">
                                  <product-list-view :item="item" :checkout="true" :quantity="item.quantity"></product-list-view>
                              </vs-td>
                          </tr>
                      </tbody>
                  </template>
              </vs-table>
          </div>

          <!-- RIGHT COL -->
          <div class="vx-col lg:w-1/3 w-full">
              <vx-card>
                  <!--<p class="text-grey mb-3 title__cart" >Options</p>
                  <span style="color: #2c2c2c; font-weight: 600; font-size: 13px;">bla bla bla bla bla bla bla bla bla bla bla </span>
                  <vs-divider/>-->
                  <p class="font-semibold mb-3 title__cart">{{ $t('PriceDetails') }}</p>
                  <div class="flex justify-between mb-2" v-for="(item,index) in basket.products" :data="item" :key="item.id">
                      <span style="color: #2c2c2c; font-weight: 600; font-size: 13px;">{{ item.FullTitle }}</span>
                      <span style="color: #2c2c2c; font-weight: 600;"><span v-if="!userInfo.need_azn_cash">$</span>{{ item.totalAmount }}<span v-if="userInfo.need_azn_cash">&nbsp;AZN</span></span>
                  </div>
                  <vs-divider/>

                  <div class="flex justify-between font-semibold mb-3">
                      <span class="title__cart" style="display: flex; margin: auto 0;">{{ $t('total') }}</span>
                      <span style="color: #2c2c2c; font-weight: 600;font-size: 2rem"><span v-if="!userInfo.need_azn_cash">$</span>{{ basket.totalAmount }}<span v-if="userInfo.need_azn_cash">&nbsp;AZN</span></span>
                  </div>


<!--
                  <v-select v-if="userInfo.markup_group_id == 5" v-model="form.selectedUser" :options="users" :clearable="false" class="input-select vs-select&#45;&#45;input mb-6" />
-->

                  <label class="vs-input--label">{{ $t('comment') }}</label>
                  <vs-textarea v-model="form.comment" :lol="true" style="margin-bottom: 0 !important;" />

                  <!-- FieldType: 1 - input text, 2 - checkbox Boolean, 3 - select -->
                  <template v-for="input in basket.form">
                      <vs-input
                          v-if="input.FieldType === '1'"
                          class="w-full mt-4"
                          :name="input.FieldName"
                          :label="input.FieldTitle+(input.Required === 'true' ? ' *' : '')"
                          v-model="form[input.FieldName]"

                          v-validate="dynamicRules(input)"
                      />
                      <template v-if="input.FieldType === '2'">
                        <vs-checkbox v-model="form[input.FieldName]" class="w-full mt-4">
                            &nbsp;&nbsp;{{ input.FieldTitle+(input.Required === 'true' ? ' *' : '') }}
                        </vs-checkbox>
                      </template>
                      <span class="text-danger text-sm">{{ errors.first(input.FieldName) ? errors.first(input.FieldName).replace(input.FieldName, input.FieldTitle) : '' }}</span>
                  </template>


                  <vs-alert v-if="basket.totalUsdAmount > userInfo.limit" color="danger" class="my-3 mt-4">
                      <span v-html="$t('NotEnoughMoney')" />
                  </vs-alert>
                  <vs-button class="w-full mt-4" @click="placeOrder" v-else>{{ $t('PLACEORDER') }}</vs-button>
              </vx-card>
          </div>
      </div>

      <!-- IF NO ITEMS IN CART -->
      <vx-card :title="$t('net_tovara_v_korzine')" v-else>
          <vs-button @click="$router.push('/pages/products')">{{ $t('BrowseProducts') }}</vs-button>
      </vx-card>

  </div>
</template>

<script>
  import ProductListView from '../components/ProductListView.vue';
  import vSelect from 'vue-select'

  export default {
      components: {
          ProductListView,
          'v-select': vSelect,
      },
    data() {
      return {
          userInfo: window.userInfo,
          basket : [],
          users: [],
          form: {
              selectedUser: {id: window.userInfo.id, label: window.userInfo.name},
              comment: '',
              IsLegalPerson: false,
          },
          validateForm() {
              return !this.errors.any();
          },

          show: false,
          selected: [],
          itemsPerPage: 10,
          isMounted: false,
      }
    },
      created(){
          this.basket = this.$store.state.basket;

          if (this.basket.form){
              for (const key in this.basket.form){
                  let formData = this.basket.form[key];

                  let setData = '';
                  if (formData.FieldType === '1') setData = '';
                  else if (formData.FieldType === '2') setData = false;
                  //else if (formData.FieldType === '3') setData = [];

                  this.form[formData.FieldName] = setData;
              }
          }

          /*if (this.userInfo.markup_group_id == 5) {
              const thisIns = this;
              axios.get(apiUrl + '/users?token=' + token)
                  .then(function (response) {

                      let data = response.data;
                      if (data.code === 200) {

                          let users = [];
                          users.push({
                              'id' : userInfo.id,
                              'label' : userInfo.name,
                          });
                          data.data.forEach(function (user) {
                              users.push({
                                  'id' : user.id,
                                  'label' : user.name,
                              });
                          });

                          thisIns.users = users;
                      } else {
                          if (data.code === 401) {
                              window.logout();
                          }
                          thisIns.$vs.notify({
                              title: 'Error',
                              text: data.message,
                              color: 'danger',
                              iconPack: 'feather',
                              icon: 'icon-alert-circle'
                          });
                      }
                  });
          }*/

      },
    computed: {
        currentPage() {
            if (this.isMounted) {
                return this.$refs.table.currentx
            }
            return 0
        },
    },
    methods: {
          dynamicRules(input){
              let rules = {};

              if (input.Required === 'true') rules.required = true;
              if (input.FieldName === 'Email') rules.email = true;
              rules.regex = input.RegExprs;

              return rules;
          },
        placeOrder(){
            const thisIns = this;
            this.$vs.loading();

            /*if (this.userInfo.markup_group_id == 5) {
                this.form.who_buy = this.form.selectedUser.id;
            }*/

            axios.post(apiUrl+'/basket/order?token='+token, this.form)
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        window.updateMyProfile();
                        thisIns.$store.dispatch('basket/reloadData', data.data);
                        thisIns.$router.push('/pages/orders');
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });
        }
    },
      mounted() {
          this.isMounted = true;
      }
  }
</script>

<style lang="scss">
    .td-check {
        display: none !important;
    }

    #data-list-list-view {
        .vs-con-table {

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 20px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                display: none;
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
